<template>
  <div  :style='{width: panelWidth}' >
    <!-- <table width='100%' class='table clientTable' v-if='data && data.length'>
      <tr>
        <th width='40%' class='colTitle'>{{ $t("Asset") }}</th>
        <th width='30%' class='colTitle'>{{ $t("P&L") }}</th>
        <th width='30%' class='colTitle'>{{ $t("Exposure") }}</th>
      </tr>
      <tr v-for='(inst, index) in data' :key='inst.instrumentList' v-if='index < count'>
        <td  width='40%' class='rowTitle'>{{ inst.instrumentName }}</td>
        <td  width='30%' class='rowData' :class='inst.profitAndLoss >= 0  ? "positive" : "negative"'>{{ inst.profitAndLoss | formatAmount }}</td>
        <td  width='30%' class='rowData' :class='inst.exposure >= 0  ? "positive" : "negative"'>{{ inst.exposure | formatAmount }}</td>
      </tr>
    </table>
    <div class='nodata' v-else>{{ $t("No data")}}</div> -->

    <lu-hbox lu-flex lu-vcenter :style="divStyles">
      <lu-vbox lu-flex>
        <lu-hbox>
          <lu-item lu-hcenter class="title" style="width: 70%">Position Risk Requirement</lu-item>
          <lu-item lu-hcenter class="title" style="width: 30%">Total NOP</lu-item>
        </lu-hbox>
        <lu-hbox lu-flex>
          <lu-vbox lu-flex style="width: 70%">
            <doughnut-chart :chart-data="chartData" :styles="chartStyles" :options="chartOptions"></doughnut-chart>
          </lu-vbox>
          <lu-vbox lu-flex style="width: 30%">
            <lu-vbox lu-flex lu-vcenter>
              <lu-item lu-hcenter>
                <el-progress class="progress" type="dashboard" :percentage="percentage" :color="colors" :show-text="false" :width="progressWidth"></el-progress>
              </lu-item>
              <lu-item lu-hcenter class="tableTitle" style="font-weight: bold;">{{ exposure | formatAmount }} / {{ maxNOP | formatAmount }} USD</lu-item>
            </lu-vbox>
          </lu-vbox>
        </lu-hbox>
      </lu-vbox>
    </lu-hbox>

    <!-- <el-table
      class='riskTable'
      :data="data"
      :height="panelHeight"
      fit
      :row-class-name="tableRowClassName"
      style="width: 100%;"
    >
      <el-table-column :label="$t('Asset')" sortable prop='instrumentName' align="left" />
      <el-table-column :label="$t('P&L')" sortable prop='profitAndLoss' :sort-method='(a,b) => sortFloat(a,b,"profitAndLoss")' align="center">
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.profitAndLoss >= 0  ? "positive" : "negative"'>{{ scope.row.profitAndLoss | formatAmount }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Exposure')" sortable prop='exposure' :sort-method='(a,b) => sortFloat(a,b,"exposure")' align="center">
        <template slot-scope="scope">
          <div style='text-align: right' :class='scope.row.exposure >= 0  ? "positive" : "negative"'>{{ scope.row.exposure | formatAmount }}</div>
        </template>
      </el-table-column>
    </el-table> -->


    <el-drawer :append-to-body="true" ref="categoryConfigDrawer" :title="$t('Category Config')" :visible.sync="showDialog" direction="rtl" size="60%" destroy-on-close :before-close="handleClose" :modal="false">
      <div class="handle-button-close" @click='closeDialog'>
        <i class="el-icon-close" />
      </div>
      <category-config />
    </el-drawer>

  </div>
</template>

<script>
import { LuHbox, LuVbox, LuItem } from 'lusis-ui'
import utils from '@/utils/formatNumber'
import CategoryConfig from './components/categoryConfig'
import DoughnutChart from './components/DoughnutChart.js'
import monitoringMixin from './mixins'
import { mapState } from 'vuex'

export default {
  name: 'BookSummary',
  components: { LuHbox, LuVbox, LuItem, CategoryConfig, DoughnutChart },
  mixins: [ monitoringMixin ],
  props: [ 'data', 'panel'],
  filters: {
    formatAmount: function (value) {
      return utils.formatAmount(value, 2, 3)
    }
  },
  data: function () {
    return {
      showDialog: false,
      datacollection: {},
      levelColor: [
        '#66FF66', // level 0
        '#FFCC66', // level 1
        '#FF9966', // level 2
        '#FF5050' // level 3
      ],
      colors: [
        {color: '#5cb87a', percentage: 50},
        {color: '#f56c6c', percentage: 100},
      ],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
            labels: {
                // This more specific font property overrides the global property
                fontColor: 'white'
            },
            position: 'left'
        },
        tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                  return `${data.labels[tooltipItem.index]}: ${data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]} M USD`
                }
            }
        }
      }
    }
  },
  methods: {
    onSettings () {
      this.showDialog = !this.showDialog
    },
    handleClose(done) {
      this.showDialog = false
      setTimeout(() => {
        done();
        // animation takes time
        setTimeout(() => {
        }, 400);
      }, 600);
    },
    closeDialog () {
      if (this.$refs.categoryConfigDrawer)
        this.$refs.categoryConfigDrawer.closeDrawer()
    },
  },
  computed: {
    ...mapState({
      riskFullScreen: state => state.app.riskFullScreen
    }),
    progressWidth () {
      if (this.riskFullScreen) {
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
        return 0.2 * vw
      }
      // default
      return 126
    },
    divStyles () {
      if (this.riskFullScreen) {
        return {
          height: 'calc(100vh - 120px)',
          position: 'relative'
        }
      } else {
        return {
          height: `${this.panelHeight}px`,
          position: 'relative'
        }
      }
    },
    chartStyles () {
      if (this.riskFullScreen) {
        return {
          height: 'calc(60vh - 120px)',
          position: 'relative'
        }
      } else {
        return {
          height: `${this.panelHeight - 40}px`,
          position: 'relative'
        }
      }
    },
    chartData () {
      const datacollection = {
        labels: [],
        datasets: [
          {
            backgroundColor: [],
            data: []
          }
        ]
      }

      if (this.data[0] && this.data[0].instrumentList) {
        this.data[0].instrumentList.forEach(s => {
          datacollection.labels.push(s.instrumentName)
          datacollection.datasets[0].backgroundColor.push(this.levelColor[s.level])
          datacollection.datasets[0].data.push(s.exposure)
        })
      }
      return datacollection
    },
    percentage () {
      let percentage = 0
      if (this.data[0]) {
        let exposure = parseFloat(this.data[0].exposure)
        let maxNOP = parseFloat(this.data[0].maxNOP)

        if (!isNaN(exposure) && !isNaN(maxNOP) && maxNOP!==0) {
          percentage = (100 *exposure) / maxNOP
          percentage = Math.round(percentage)
        }
      }

      if (percentage>100) {
        percentage = 100
      }
      return percentage
    },
    exposure () {
      let value = 0
      if (this.data[0]) {
        value = parseFloat(this.data[0].exposure)
      }
      return value
    },
    maxNOP () {
      let value = 0
      if (this.data[0]) {
        value = parseFloat(this.data[0].maxNOP)
      }
      return value
    }
  },
}
</script>

<style lang='scss'>

.progress {
  .el-progress__text {
    color: white;
  }
}
  
</style>